import React, { useState } from 'react';
import api from './api';


function Login({ onLoginSuccess }) {
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const response = await api.post('/api/auth/login', formData);

            sessionStorage.setItem('token', response.data.token);

            // 1. Success message
            console.log("UserData:", response.data.user);

            // 2. TRIGGER THE SWITCH: This tells App.js to show the Sidebar/Dashboard
            onLoginSuccess(response.data.user); 
            
        } catch(err) {
            alert("Login failed: " + (err.response?.data?.error || "Invalid Credentials"));
        }
    };

    return (
        <div className="auth-card">
            <h2>Login</h2>
            <form onSubmit={handleLogin}>
                <input 
                    type="email"
                    placeholder="Email"
                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                    required
                /><br />
                <input 
                    type="password"
                    placeholder='Password'
                    onChange={(e) => setFormData({...formData, password: e.target.value})}
                    required
                /><br />
                <button type="submit">Login</button>
            </form>  
        </div>
    );
}

export default Login;